<template>
  <div>
    <page-title-bar>
        <v-menu offset-y>
          <v-btn fab dark color="indigo" small slot="activator">
            <v-icon dark>add</v-icon>
          </v-btn>

          <v-list>
            <v-list-tile
              v-for="(item, index) in availableWidgets"
              :key="index"
              @click="addWidget(item)"
            >
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn fab dark color="indigo" small @click="isDashboardEditorDialogVisible = true">
          <v-icon dark>edit</v-icon>
        </v-btn>
    </page-title-bar>
    <!-- <page-title-bar></page-title-bar> -->
    <v-container fluid pt-0 grid-list-xl v-if="tempDashboard">
      <section-tooltip :title="tempDashboard.settings.name[$i18n.locale]" :tooltip="tempDashboard.settings.description[$i18n.locale]"></section-tooltip>
      <!-- <v-layout row wrap>
        <app-card
          :heading="$t('message.standard')"
          :fullBlock="true"
          colClasses="xl12 lg12 md12 sm12 xs12">
          <div class="pa-3"> <v-flex xs12>
            <v-slider
                v-model="dashboardColumns"
                hint="sasda"
                label="Dashboard columns"
                max="6"
                min="1"
                thumb-label="always"
                ></v-slider>
            </v-flex>
          </div>
        </app-card>
      </v-layout>-->
      <grid-layout
        v-if="tempDashboard !== null"
        :layout="widgetLayout"
        :col-num="tempDashboard.settings.columns"
        :row-height="30"
        :is-draggable="true"
        :is-resizable="true"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[10, 10]"
        :use-css-transforms="true"
      >
        <grid-item
          v-for="item in tempDashboard.widgets"
          :key="item.config.layout.i"
          :x="item.config.layout.x"
          :y="item.config.layout.y"
          :w="item.config.layout.w"
          :h="item.config.layout.h"
          :i="item.config.layout.i"
          class="widget-container"
        >
          <widget-renderer class="widget" :widget="item.config"></widget-renderer>
          <div class="widget-overlay">
            <v-container fluid fill-height>
              <v-layout align-center justify-center>
                <div>
                  <v-btn fab dark color="primary" @click="editWidget(item)">
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  <v-btn fab dark color="error" @click="removeWidget(item)">
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                </div>
              </v-layout>
            </v-container>
          </div>
        </grid-item>
      </grid-layout>
      <div
        class="no-widget-text"
        v-if="tempDashboard && tempDashboard.widgets.length === 0">There are no Widgets on this dashboard.
        <br>Click the
        <v-btn fab dark color="indigo">
          <v-icon dark>add</v-icon>
        </v-btn>button to add one.
      </div>
      <widget-editor-dialog
        :is-visible="isWidgetEditorDialogVisible"
        :widget="selectedWidget"
        v-on:close="onWidgetEditorDialogClose"
      ></widget-editor-dialog>
      <dashboard-editor-dialog
        v-if="tempDashboard !== null"
        :dashboard="tempDashboard"
        :is-visible="isDashboardEditorDialogVisible"
        v-on:close="onDashboardEditorDialogClose"
      ></dashboard-editor-dialog>
    </v-container>
    <!-- <widget-customizer :widget="selectedWidget" v-on:close="widgetCustomizerClosed"></widget-customizer> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueGridLayout from 'vue-grid-layout'
import { debounce } from 'lodash'
import WidgetRenderer from 'Components/Widgets/widget-renderer'
import DashboardEditorDialog from './DashboardEditorDialog'
import WidgetEditorDialog from './WidgetEditorDialog'
import availableWidgets from './widget-list.js'

export default {
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    DashboardEditorDialog,
    WidgetEditorDialog
  },
  data() {
    return {
      model: 'tab-settings',
      isDashboardEditorDialogVisible: false,
      isWidgetEditorDialogVisible: false,
      selectedWidget: null,
      tempDashboard: null,
      availableWidgets
    };
  },
  computed: {
    ...mapGetters([
      'dashboard'
    ]),
    widgetLayout: function() {
      return this.tempDashboard.widgets.map(widget => widget.config.layout)
    }
  },
  watch: {
    dashboard(val) {
      this.tempDashboard = Object.assign({}, JSON.parse(JSON.stringify(val)))
    },
    tempDashboard: {
      handler(newVal, oldVal) {
        if (oldVal !== null) {
          this.debouncedDashboardUpdate(newVal)
        }
      },
      deep: true
    }
  },
  methods: {
    widgetCustomizerClosed(widgetEdited) {
      this.selectedWidget = null
    },
    addWidget(widgetDefault) {
      widgetDefault.config.layout.i = Date.now()
      this.tempDashboard.widgets.push(
        Object.assign({}, JSON.parse(JSON.stringify(widgetDefault)))
      )
    },
    editWidget(item) {
      this.selectedWidget = item
      this.isWidgetEditorDialogVisible = true
      console.log(item)
    },
    removeWidget(item) {
      const widget = this.tempDashboard.widgets.find(widget => widget.config.layout.i === item.config.layout.i)
      this.tempDashboard.widgets.splice(
        this.tempDashboard.widgets.indexOf(widget),
        1
      )
    },
    onDashboardEditorDialogClose() {
      this.isDashboardEditorDialogVisible = false;
    },
    onWidgetEditorDialogClose() {
      this.isWidgetEditorDialogVisible = false;
    }
  },
  created() {
    if (this.$route.params.id) {
      this.$store.dispatch('getDashboard', this.$route.params.id);
    } else {
    }
    this.debouncedDashboardUpdate = debounce(
      val => this.$store.dispatch('updateDashboard', val),
      400
    );
  },
  mounted() {
    // if (this.$route.params.id) {
    //     this.$store.dispatch('getDashboard', { id: 1 })
    // } else {
    //     this.$store.dispatch('newDashboard', defaultDashboard)
    // }
    this.$store.dispatch('getUsers')

  }
};
</script>
<style>
.vue-grid-item.vue-grid-placeholder {
  background-color: rgb(53, 53, 53);
}

.widget-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background: #464c69;
  /* filter:blur(4px);
        -o-filter:blur(4px);
        -ms-filter:blur(4px);
        -moz-filter:blur(4px);
        -webkit-filter:blur(4px); */
}

.widget-container:hover .widget-overlay {
  opacity: 0.8;
}


</style>